// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__206P_","comment":"styles_comment__2WwbE"};